module.exports = __webpack_public_path__ + "static/educative-quiz-a219d90e2b7a43ed1158f2e7254ef671.mp4";